import * as z from "zod";

const SearchResultShipment_ = z.object({
  id: z.string(),
  shipmentId: z.string().nullable(),
  trackingNumber: z.string().nullable(),
  status: z.string().nullable(),
  productCount: z.number(),
});
export const SearchResultShipment: z.ZodType<SearchResultShipment> =
  SearchResultShipment_;
export interface SearchResultShipment
  extends z.infer<typeof SearchResultShipment_> {}

const SearchResultItem_ = z.object({
  type: z.enum(["purchaseOrder", "inboundShipment"]),
  purchaseOrderId: z.string().nullable(),
  poNumber: z.string().nullable(),
  status: z.string().nullable(),
  supplierName: z.string().nullable(),
  shipments: z.array(SearchResultShipment),
  productCount: z.number(),
  expectedCount: z.number(),
  receivedCount: z.number(),
  // For direct shipment matches
  inboundShipmentId: z.string().nullable(),
  shipmentId: z.string().nullable(),
  trackingNumber: z.string().nullable(),
});
export const SearchResultItem: z.ZodType<SearchResultItem> = SearchResultItem_;
export interface SearchResultItem extends z.infer<typeof SearchResultItem_> {}

export const searchReceivableShipments = {
  name: "searchReceivableShipments" as const,
  input: z.object({ search: z.string(), locationId: z.string() }),
  output: z.object({ results: z.array(SearchResultItem) }),
};
